<template>
    <div class="wrapper">
        <section class="content alineacion">
            <form @submit.prevent="updateLock()">
                    <div class="form-row">
                        <div class="form-group col-md-12">          
                            <label for="inputState">{{$t('lockNameUpdate')}}</label>
                                <select id="inputState" class="form-control" v-model="Lock">
                                    <option disabled value>{{$t('keySelection')}}</option>
                                    <option v-for=" lock in datosLocker" :key="lock.lastUpdate" :value="lock">{{lock.brief_desc}}</option>
                                </select>
                        </div>
                    </div>
                    <div class="form-row">   
                            <div class="form-group col-md-6">
                                <label for="nameInputLock">{{$t('lockNewNameUpdate')}}</label>
                                <input 
                                v-model="lockToUpdate.name"          
                                type="text"
                                class="form-control"
                                id="nameInputLock"
                                aria-describedby="LockHelp"       
                                :placeholder=Lock.brief_desc
                                >
                            </div>
                            <div class="form-group col-md-6">
                                <label for="nameInputDescription">{{$t('lockNewDescriptionUpdate')}}</label>
                                <input
                                v-model="lockToUpdate.description"                        
                                type="text"
                                class="form-control"
                                id="nameInputDescription"
                                :placeholder=Lock.description>
                            </div>
                    </div>                             
                    <button type="submit" class="btn btn-primary">{{$t('lockUpdateButton')}}</button>
            </form>
        </section>
    </div>              
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
    data(){
        return{
            Lock: {},
            datosLocker: [],
            lockToUpdate:{
                id:"",
                name:"",
                description:""
            }
        };
    },
    methods: {
        lockersAvailable() {
            // console.log("Entra por aquí");
            var login = JSON.parse(localStorage.getItem("session"));

            this.axios
                .get("https://lightkey.es:3000/lightkey/api/owner/locks", {
                headers: { authorization: login.session }
                })
                .then(response => {
                // console.log("respuesta de locks disponibles", response.data);
                response.data.forEach(dato => {
                    this.datosLocker.push(dato);
                });
                console.log(this.datosLocker[0]);

                /* 
                console.log("Array rooms", this.datosLocker);
                this.rooms = this.datosLocker.map(room => room.brief_desc);
                console.log("Rooms", this.rooms); */
                })
                .catch(err => {
                    console.error("Ocurrio un error cargando usuarios", err);
                    this.$router.replace("/");
                });
        },
        updateLock(event){
            var login = JSON.parse(localStorage.getItem("session"));
            //Si no se ha seleccionado una cerradura
            if(!this.Lock.brief_desc){
                switch(i18n.locale){
                    case "en":
                    this.$toastr.e(i18n.messages.en.errorUpdateLocker);
                    break;
                    case "es":
                    this.$toastr.e(i18n.messages.es.errorUpdateLocker);
                    break;
                    case "de":
                    this.$toastr.e(i18n.messages.de.errorUpdateLocker);
                    break;  
                }
            }else{
                //Si no se ha introducido un nombre o una descripcion de la cerradura
                if((!this.lockToUpdate.name)&&(!this.lockToUpdate.description)){
                    switch(i18n.locale){
                        case "en":
                        this.$toastr.e(i18n.messages.en.errorUpdateLocker);
                        break;
                        case "es":
                        this.$toastr.e(i18n.messages.es.errorUpdateLocker);
                        break;
                        case "de":
                        this.$toastr.e(i18n.messages.de.errorUpdateLocker);
                        break;  
                    }
                }else{
                    //Si no se ha introducido nueva descripcion de la cerradura se coga la antigua
                    if((this.lockToUpdate.name)&&(!this.lockToUpdate.description)){
                        this.lockToUpdate.description=this.Lock.description;
                    //Si no se ha introducido nuevo nombre de la cerradura se coge el anterior    
                    }else if((!this.lockToUpdate.name)&&(this.lockToUpdate.description)){
                        this.lockToUpdate.name=this.Lock.brief_desc;
                    }
                    this.lockToUpdate.id=this.Lock.deviceId;
                    this.axios.put("https://lightkey.es:3000/lightkey/api/locks/",
                        {data : this.lockToUpdate},
                        {headers : { authorization: login.session }}
                    )
                    .then(response => {
                        console.log(response.data);
                        switch(i18n.locale){
                            case "en":
                                this.$toastr.s(i18n.messages.en.lockerUpdate);
                                break;
                            case "es":
                                this.$toastr.s(i18n.messages.es.lockerUpdate);
                                break;
                            case "de":
                                this.$toastr.s(i18n.messages.de.lockerUpdate);
                                break;  
                        }
                        this.$router.replace('/dashboard/view-users');
                    })
                    .catch(error => {
                        console.log(error);
                        switch(i18n.locale){
                            case "en":
                                this.$toastr.s(i18n.messages.en.lockerNotUpdate);
                                break;
                            case "es":
                                this.$toastr.s(i18n.messages.es.lockerNotUpdate);
                                break;
                            case "de":
                                this.$toastr.s(i18n.messages.de.lockerNotUpdate);
                                break;  
                        }
                    });
                    console.log("Lock",this.Lock);
                    console.log("locker",this.locker);
                }
            }               
        },
        setLanguage(){
            if(localStorage.getItem('language')){
                console.log(localStorage.getItem('language'));
                i18n.locale = localStorage.getItem('language'); 
            }else{
                console.log("No hay lenaguaje");
            }
        }
    },
    created() {
        this.lockersAvailable();
        this.setLanguage();
    }
}
</script>

<style>
.wrapper {
  display: grid;
  grid-template-columns: 1fr 1100px 1fr;
}

.content{
    grid-column: 2/3;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/children/Locks.vue